import React,{useContext, useState} from "react";
import { CUSTOM_STYLES, CXR_SUBTABS_ID, CXR_TABS, CXR_TABS_ALLOWED_ROLES, USERTYPES } from "../../../../constants/Constants";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { Pivot, PivotItem, PrimaryButton } from '@fluentui/react';
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { HeightTool } from "@cornerstonejs/tools";
import userContext from "../../../../context/users/UserContext";
import './CXRNavTabs.css';

const CXRNavTabs = () => {

    const {
        roles,
        selectedValue,
        handleCXRTabChange,
        handleBlitzReporting,
        studyBlitzFilter, setStudyBlitzFilter
      } = useContext(studylistContext);

    const { getThemeColor } = useContext(themeContext);

    const { isActiveData, blitzSessionEnabled } = useContext(userContext);

    const toolTipProps = {
      calloutProps: {
        styles: {
          beak: { background: getThemeColor("tooltip"),border:getThemeColor("tooltip-border"),borderTop:`1px solid ${getThemeColor("hide-tooltip-border")}`,borderLeft:`1px solid ${getThemeColor("hide-tooltip-border")}`,zIndex:"100",borderRadius:'1px',boxShadow:"none"},
          beakCurtain: { background: getThemeColor("tooltip"),border:getThemeColor("tooltip-border") },
          calloutMain: { background: getThemeColor("tooltip") },
          borderRadius: "5px",
        },
      },
    };
    const loadSelectedXrayTab = (item)=>{
        if(item.props.itemKey === 'unreported'){
         handleCXRTabChange(item.props.itemKey, CXR_TABS.unreported, "study_1")
       }else if(item.props.itemKey === 'normal'){
         handleCXRTabChange(item.props.itemKey, CXR_TABS.normal, "study_11")
       }else if(item.props.itemKey === 'normalwithfb'){
         handleCXRTabChange(item.props.itemKey, CXR_TABS.normalWithFB, "study_12")
       }else if(item.props.itemKey === 'abnormal'){
         handleCXRTabChange(item.props.itemKey, CXR_TABS.abnormal, "study_13")
       }
     }

    return (
      <>
        {(CXR_SUBTABS_ID.includes(selectedValue) && CXR_TABS_ALLOWED_ROLES.includes(roles[0])) && (
          <>
            <div style={{  background: "var(--studylist-search-and-tab-section-background)"}}>
               <div style={{position : "relative", 
                borderLeft: getThemeColor("border"), 
                borderTop: getThemeColor("border"),
                borderRight: getThemeColor("border"),
                background: "var(--background-theme-color)",
                display: "flex",          // make it flex
                alignItems: "center",     // vertical alignment
                justifyContent: "space-between",
               }} className="xray-tabs-pivot-top">
                <div className="study-list-hide-cxr-border-top"></div>
                <Pivot  className="xray-tabs-pivot"
                aria-label="Xray tabs"
                linkSize="small"
                linkFormat={'tabs'}
                onLinkClick={(item) => loadSelectedXrayTab(item)}
                >       
                  <PivotItem headerText={t("study-list.tabs.all-studies")} itemKey="unreported"></PivotItem>
                  <PivotItem  headerText={<CustomToolTipHost toolTipProps={toolTipProps} content={t("study-list.cxr-tooltip.cxr-no-suspicions")}> {t("study-list.tabs.cxr-no-suspicions")}</CustomToolTipHost>} itemKey="normal"> </PivotItem>
                  <PivotItem  headerText={<CustomToolTipHost toolTipProps={toolTipProps} content={t("study-list.cxr-tooltip.cxr-fo-only")}> {t("study-list.tabs.cxr-fo-only")}</CustomToolTipHost>} itemKey="normalwithfb"></PivotItem>
                  <PivotItem  headerText={<CustomToolTipHost toolTipProps={toolTipProps} content={t("study-list.cxr-tooltip.cxr-with-suspicions")}> { t("study-list.tabs.cxr-with-suspicions")}</CustomToolTipHost>} itemKey="abnormal"></PivotItem>
                </Pivot>

                {blitzSessionEnabled && 
                  <>
                    <div className="blitz-area">
                      {roles[0] === USERTYPES.RADIOLOGIST &&
                        <div className="toggle-button-group">
                          <button className={`toggle-button ${studyBlitzFilter === "any" ? "active" : ""}`} onClick={() => setStudyBlitzFilter("any")}>
                            Any
                          </button>
                          <button className={`toggle-button ${studyBlitzFilter === "normal" ? "active" : ""}`} onClick={() => setStudyBlitzFilter("normal")}>
                            Normal
                          </button>
                          <button className={`toggle-button ${studyBlitzFilter === "abnormal" ? "active" : ""}`} onClick={() => setStudyBlitzFilter("abnormal")}>
                            Abnormal
                          </button>
                        </div>
                      }
                      <PrimaryButton
                        onClick={handleBlitzReporting} 
                        text={"Blitz Session"} 
                        style={{marginRight:'10px'}} 
                        disabled={!isActiveData}/>
                    </div>
                  </>
                }
              </div>
            </div>
          </>
        )}
      </>
    )
}

export default CXRNavTabs;